// @ts-check

// public course information
const courses = [
  // writing Cypress tests using Cursor AI course
  {
    courseId: 'couc7zn69u',
    slug: 'cy-cursor',
    title: 'Cursor AI For Cypress Testing',
    description:
      'Accelerate your Cypress test implementation speed using Cursor AI code editor and project-specific LLM instructions.',
    lessons: {
      intro: 'le8mqec6a9',
      introduction: 'le8mqec6a9',
      a1: 'le0ifdmo9e',
      a2: 'legvijmprb',
      a3: 'lelcqtnb5m',
      a4: 'let7gn4nku',
      a5: 'lens34rybc',
      a6: 'lea6ikud8v',
      a7: 'legpqrzvgd',
      b1: 'le4kyba6qu',
      b2: 'leetibcq3p',
      b3: 'lexdc1w0r7',
      b4: 'lei3g8bdru',
      b5: 'le1j7263qn',
      b6: 'led6stfas8',
      b7: 'leox7l7hnj',
      b8: 'lexzcbickp',
      b9: 'lezd48wg65',
      b10: 'leexw6qm98',
      c1: 'leser2n9g5',
      c2: 'le0uxzezed',
      c3: 'le1ykl0euj',
      c4: 'le72knpv2j',
      c5: 'lez7vsvqew',
      c6: 'lenmd35o1o',
      c7: 'lecns0bppk',
      c8: 'leib7u046j',
      c9: 'leq13irnjj',
      d1: 'le0z6gr198',
      d2: 'leut8udvzj',
      d3: 'leup1xf7qr',
      d4: 'ledv7o0y5n',
      d5: 'leoajrogb8',
    },
  },

  // tdd calculator course
  {
    courseId: 'con6p7gvh5',
    slug: 'tdd-calculator',
    title: 'TDD Calculator',
    description: 'TDD Development of a simple HTML calculator',
    lessons: {
      intro: 'le11cx0zdz',
      introduction: 'le11cx0zdz',
      a1: 'leqkmyuriz',
      a2: 'leon51w60f',
      a3: 'le79dyilip',
      a4: 'lesqddfytr',
      a5: 'lecizyen8p',
      a6: 'lelngp8xhv',
      b1: 'lerof9gswi',
      b2: 'lexlsoww43',
      b3: 'letagjzi8q',
      b4: 'leuethvftk',
      b5: 'lebhc0c4m6',
      b6: 'lex9z4n3ue',
      b7: 'le1ee2v3et',
      c1: 'lespu0qm5f',
      c2: 'le8bakirr2',
      c3: 'le2as8r5ja',
      c4: 'leez5rdto9',
      c5: 'leqxc11mks',
      c6: 'lexyn10uta',
      c7: 'le9665ktxh',
      c8: 'leg6tj1l2q',
      c9: 'lep9v7zhr1',
      c10: 'lemr5c7yy3',
      d1: 'leygfrxahg',
      d2: 'lekqv9ht2w',
      d3: 'lehoq07gk1',
      d4: 'levjxhksk1',
      d5: 'lek8s21e5v',
      d6: 'leo09mb6op',
      d7: 'leug6q0lqy',
      d8: 'levcigupte',
      d9: 'le8y9c0ruo',
      d10: 'leba7g6o0i',
      d11: 'leofmbfx64',
      e1: 'le7d6jzns9',
      e2: 'lek3ulxa44',
      e3: 'lecick0n8g',
      e4: 'lehghs33kk',
      e5: 'leoeyat98x',
      e6: 'ler3iwe06s',
      e7: 'leffavha35',
      f1: 'lecw03x8k4',
      f2: 'lenvb18irb',
      f3: 'ledrg8al7d',
      f4: 'ledrg8al7d',
      f5: 'leyenzy110',
      f6: 'leofv55y39',
      f7: 'le2go13u06',
      g1: 'lev5ilmsv2',
      g2: 'le2rj0csdz',
      g3: 'le0r45t5rm',
      g4: 'le6j8v3iul',
      g5: 'le7pi8ob96',
      g6: 'lev5b29gpi',
      g7: 'leiwbm2aav',
      g8: 'lepsu5xlfz',
      h1: 'le0dbdjm89',
      h2: 'le5x6688o5',
      h3: 'le6n1nsfr8',
      h4: 'lerg5w1ija',
      finish: 'lecr5dbv7a',
    },
  },
  // cypress github copilot course
  {
    courseId: 'co7fdsq21w',
    slug: 'cy-copilot',
    title: 'Write Cypress Tests Using GitHub Copilot',
    description:
      'Accelerate your Cypress test implementation speed using GitHub Copilot.',
    lessons: {
      contents: 'lehxd6tnz8',
      a1: 'lej9p3k2i0',
      a2: 'leppky40ln',
      a3: 'le6in0ex99',
      a4: 'le52k8rqu9',
      a5: 'leyzwqozoc',
      a6: 'lereavepyu',
      a7: 'leiaecbat4',
      a8: 'le22oi57hg',
      a9: 'lehesr8ppk',
      b1: 'lemo3efiz1',
      b2: 'le3agyv9at',
      b3: 'lee1b8ohwh',
      b4: 'lehf8o71vq',
      b5: 'leodif2il5',
      b6: 'leci5v5l48',
      b7: 'ler15ib304',
      b8: 'lewll5lzjg',
      end: 'leu81ax0iz',
      bonus01: 'lecwytqu8a',
      bonus02: 'leyzht58lx',
      bonus03: 'le64x2g7q9',
      bonus04: 'lensv0jvev',
      bonus05: 'let67psb95',
      bonus06: 'let7h1pbb7',
      bonus07: 'leu7ofx8yb',
      bonus08: 'le3hxmu2kj',
      bonus09: 'lenbpzw6zs',
      bonus10: 'le9lfywma3',
    },
  },
  // cypress split plugin
  {
    courseId: 'cov1ad6pdh',
    slug: 'cypress-split',
    title: 'Cypress-Split Plugin',
    description:
      'This course teaches how to configure the cypress-split plugin',
    lessons: {
      a1: 'letyefhgb8',
      a2: 'lei3nazqpn',
      a3: 'lehhhotd2d',
      a4: 'lep5h3j2an',
      a5: 'lep0uwondk',
      a6: 'le3omewvfg',
      a7: 'le2bh7ar8d',
      b1: 'leah124knc',
      b2: 'le98ttt045',
      b3: 'le06f1z1mk',
      b4: 'lebuf0iolq',
      b5: 'len27izdqc',
      b6: 'lewdmpt2ez',
      b7: 'leg09wytpb',
      b8: 'leywyo7pib',
      c1: 'lej8ari8iy',
      c2: 'lerojv05xa',
    },
  },
  // cypress vs playwright
  {
    courseId: 'co7afj5vav',
    slug: 'cypress-vs-playwright',
    title: 'Cypress vs Playwright',
    description: 'Learn both testing tools in this course',
    lessons: {
      contents: 'lefa5ipi0q',
      a1: 'lewl65a1w0',
      a2: 'lebsokv68w',
      a3: 'le0psw4bat',
      a4: 'le6h581o9x',
      a5: 'lext6ygdu6',
      a6: 'le5j9wo6ig',
      a7: 'lej3zhaqxq',
      a8: 'led4ok9do3',
      b1: 'le5tq08qbq',
      b2: 'lefw6mkbyu',
      b3: 'lef690u7ye',
      b4: 'lec42plsyo',
      b5: 'leabi04ma2',
      b6: 'leqznv8cw0',
      b7: 'lelfpmfpu4',
      b8: 'le42j2ipk4',
      b9: 'le5t28utmg',
      c1: 'leurceh8ez',
      c2: 'leujhnpp0z',
      c3: 'le5jia1tu1',
      c4: 'ley0jw0bv4',
      c5: 'lefgsaqql1',
      c6: 'lenps0dp60',
      c7: 'ler5u5yygb',
      c8: 'leolmodx3r',
      c9: 'lekbys7t84',
      c10: 'lesgcvw3r1',
      c11: 'le2sdbp3oa',
      d1: 'le7le8doyp',
      d2: 'le8r2j53wl',
      d3: 'le69lwvgk6',
      d4: 'leltcc35zg',
      d5: 'ley2k15wdu',
      d6: 'le2q9b25fd',
      d7: 'lenfx0zlzx',
      d8: 'lehc1ww0bj',
      d9: 'leo9sikduh',
      d10: 'letufjluku',
      d11: 'le9dpbxoez',
      e1: 'le7p5jljpw',
      e2: 'levjpcm978',
      e3: 'le2x4horwl',
      e4: 'le9n3yudkx',
      e5: 'lep3zib6e4',
      e6: 'lexdehcch8',
      e7: 'lexn9e7iza',
      e8: 'leuvl0r6sc',
      e9: 'les27uawhk',
      f1: 'le4vssra51',
      f2: 'le3bcqch68',
      g1: 'levspamvp9',
      g2: 'le0lhmq03z',
      g3: 'leaqu40yn4',
      g4: 'lec5wc16z8',
      g5: 'lepwpr0foq',
      g6: 'let72v9wo2',
      g7: 'legzvn0xv1',
      g8: 'lewhqfcorf',
    },
  },
  // swag store
  {
    courseId: 'coj0pt0v7t',
    slug: 'swag-store',
    title: 'Testing The Swag Store',
    description: 'Writing Cypress tests for a web Swag store',
    lessons: {
      intro: 'leve2yiufl',
      introduction: 'leve2yiufl',
      lesson01: 'lep4sylb26',
      lesson02: 'le9v05efvb',
      lesson03: 'leh8qx2iw9',
      lesson04: 'legbe15nr2',
      lesson05: 'legpz2e3fx',
      lesson06: 'lem9j9ng1d',
      lesson07: 'leiifsummx',
      lesson08: 'lemr2kx3kq',
      lesson09: 'legn3znweu',
      lesson10: 'leel7y0na0',
      lesson11: 'lemqfakcs4',
      lesson12: 'leyj8bs21o',
      lesson13: 'lekt7uditf',
      lesson14: 'le1e20x9wf',
      lesson15: 'le5zs7uh4n',
      lesson16: 'leqhqz9xg7',
      lesson17: 'le9xy13dea',
      lesson18: 'lenw98t02l',
      lesson19: 'le362gxdbe',
      lesson20: 'leu2nnzdmz',
      lesson21: 'leb1c53ye7',
      lesson22: 'lemuwtj73e',
      lesson23: 'leuryy4m9i',
      lesson24: 'les9i5o62j',
      lesson25: 'lebozeblfr',
      lesson26: 'leulhjv6eb',
      lesson27: 'le8p5m13i4',
      lesson28: 'ledl61ziq1',
      lesson29: 'lem8fdot3x',
      lesson30: 'lelpfbo7i6',
      lesson31: 'leykgid6j3',
      lesson32: 'leyziuj14i',
      lesson33: 'le3dcqcut1',
      lesson34: 'le331dnozy',
      lesson35: 'leg9k81aqz',
      lesson36: 'leh8rfhai1',
      lesson37: 'leje6gyr4v',
      lesson38: 'le0caecgi1',
      lesson39: 'lestfipicu',
      lesson40: 'lehjkyrpkh',
      lesson41: 'le46jmvpes',
      lesson42: 'leurf041mc',
      lesson43: 'lehpac8gsk',
      lesson44: 'lekrqrlmnr',
      lesson45: 'ledriq45t2',
      lesson46: 'leggatxyir',
      lesson47: 'le5756b3d8',
      lesson48: 'le637vt6ce',
      lesson49: 'lew7z74jlo',
      lesson50: 'lev2npg8pb',
      lesson51: 'let0yxm8rh',
      lesson52: 'leuhd35hq6',
      lesson53: 'lecrzhix1a',
      lesson54: 'leupeksvw4',
      lesson55: 'lerpub67wk',
      lesson56: 'lewhpfmttw',
      lesson57: 'lexf1v3w4n',
      lesson58: 'leyv0qn050',
      lesson59: 'lexkbiv90w',
      lesson60: 'lex9kk7goc',
      lesson61: 'lexnyabeyx',
      lesson62: 'levomur0zs',
      lesson63: 'leq49x79at',
      lesson64: 'le80usgjpi',
      lesson65: 'lelsbzgbfl',
      lesson66: 'lefrkyqmce',
      lesson67: 'le2vumhux9',
      lesson68: 'le9b23f063',
      lesson69: 'lewculiy3y',
      lesson70: 'lea70ogmu0',
      end: 'letipecwi6',
      bonus01: 'leq615vgmu',
      bonus02: 'letojvd6r3',
      bonus03: 'led5ksgv3p',
      bonus04: 'le61yfcuwm',
      bonus05: 'lexgtymcqr',
      bonus06: 'le5p7465rx',
      bonus07: 'lenme0o7sa',
      bonus08: 'leuq0j0brl',
      bonus09: 'le076kslm9',
      bonus10: 'le6qzoutmv',
      bonus11: 'ler9ld8gm7',
      bonus12: 'le9tyrzsys',
      bonus13: 'lecd1otidi',
      bonus14: 'lejq2ul9ks',
      bonus15: 'le9pjkuwa7',
      bonus16: 'lept4yh78l',
      bonus17: 'lesvzjb7x4',
      bonus18: 'lepygef0bi',
      bonus19: 'le9glse1lv',
      bonus20: 'lez401q2gz',
      bonus21: 'lerjle6iqx',
      bonus22: 'lepq26mo9r',
      bonus23: 'lers28z5dy',
      bonus24: 'leyxpp3mvs',
      bonus25: 'le7ge2lb4p',
      bonus26: 'le8pdcbid4',
      bonus27: 'lep4s5s8ci',
      bonus28: 'le8qbispnl',
      bonus29: 'le1v4edlwa',
      bonus30: 'lecuxf3k2w',
      bonus31: 'le7ic7s8e8',
      bonus32: 'leqe18cevg',
      bonus33: 'lesbkiir8c',
      bonus34: 'leyv1htttp',
      bonus35: 'lenxhsm3wo',
      bonus36: 'le9bpye9j8',
      bonus37: 'let704cy05',
      bonus38: 'leaj0rjn5g',
      bonus39: 'lezrw8bqc5',
      bonus40: 'lesg5zwf7o',
      bonus41: 'le90dmyap5',
      bonus42: 'levru19azn',
      bonus43: 'lecxhuanck',
      bonus44: 'lefipawdxd',
      bonus45: 'lep124y1dk',
      bonus46: 'leat5gcf12',
      bonus47: 'le77nqi9tt',
      bonus48: 'leab017mxo',
      bonus49: 'le26yfkgya',
      bonus50: 'le7o8uore8',
      bonus51: 'le6ww7am6y',
      bonus52: 'lemjnrh37v',
      bonus53: 'le3ck1dx87',
      bonus54: 'lejrq60rhv',
      bonus55: 'lecfmuzyqc',
      bonus56: 'lefikcmso2',
      bonus57: 'leguoku6m1',
      bonus58: 'legz8igs3c',
      bonus59: 'lekc6yp3t1',
      bonus60: 'leukg2f1z9',
      bonus61: 'leiujco4gy',
      bonus62: 'le9p3sur2r',
      bonus63: 'le5umt2ok1',
      bonus64: 'lepbd9xb0b',
      bonus65: 'lek36xh153',
      bonus66: 'leh2w7xjt7',
      bonus67: 'le9z6lbgqd',
      bonus68: 'ley44qhyxf',
      bonus69: 'lertb2hb19',
      bonus70: 'leuc1c74cy',
      bonus71: 'ledcmd0eys',
      bonus72: 'leyxhyheg2',
      bonus73: 'lezv7tvbye',
      bonus74: 'lew3q8zuoq',
      bonus75: 'legma9bs87',
      bonus76: 'le11s1ilis',
      bonus77: 'lecoaseyth',
      bonus78: 'leb46l2s5k',
    },
  },
  // network testing
  {
    courseId: 'covt2fpsux',
    slug: 'network-testing',
    title: 'Cypress Network Testing Exercises',
    algolia: {
      applicationId: '1I3QBVLHX8',
      searchApiKey: 'ba4903b3be1708cde94afd6436ed739d',
      indexName: 'cypress_courses',
    },
    description:
      'These advanced test exercises will teach you the powerful ways of using cy.intercept, cy.request, and cy.spy commands. There are more than 45 hands-on exercises to write, show-casing the features of spying, stubbing, and making network requests from Cypress tests.',
    // redirects from human lesson ids like "bonus10" to CourseKit lesson IDs
    // IMPORTANT: make sure it matches the next.config.js redirects
    lessons: {
      intro: 'leyz2irg53',
      introduction: 'leyz2irg53',
      spec01: 'lediyqjqe4',
      spec02: 'les88612ql',
      spec03: 'ledsrym91m',
      'find-help': 'le3vvqjuv9',
      spec04: 'lev32c5ou4',
      spec05: 'let1h44hjx',
      spec06: 'le95dmhzrw',
      spec07: 'le1dcn1uff',
      spec08: 'lejvexlwuq',
      spec09: 'levx3vrc44',
      spec10: 'lenk2ozpb1',
      spec11: 'lesz9wlfba',
      spec12: 'lewgouyc1i',
      spec13: 'lekub8c3wm',
      spec14: 'letteij09y',
      spec15: 'le4p96xtjk',
      spec16: 'le88poppwn',
      spec17: 'lemtapmewp',
      spec18: 'lehkvrhadz',
      spec19: 'lecxzh50r1',
      spec20: 'le8dacsy1l',
      spec21: 'leuxna9x7i',
      spec22: 'le5eph253v',
      spec23: 'legbr9o5on',
      spec24: 'le3hre5p0v',
      spec25: 'le6v6q9hq4',
      spec26: 'lef3p3u7zd',
      spec27: 'lebli150ij',
      spec28: 'le0k05k6u0',
      spec29: 'lerp0eg48m',
      spec30: 'lesmcghjzy',
      'the-end': 'lelc0ju8vy',
      bonus01: 'lezwamthsk',
      bonus02: 'ledh8vllof',
      bonus03: 'ledgysx2ja',
      bonus04: 'le8klf95vt',
      bonus05: 'lemto852vy',
      bonus06: 'lebfw6nibf',
      bonus07: 'lel4mvl82g',
      bonus08: 'le9u14ozxi',
      bonus09: 'leix0qz2y7',
      bonus10: 'ler6gglkt1',
      bonus11: 'le2bx5yzxa',
      bonus12: 'le7qzg0g3d',
      bonus13: 'lek85tcs9o',
      bonus14: 'lerdu8ehff',
      bonus15: 'le7an3m9bs',
      bonus16: 'le1jlk0bkx',
      bonus17: 'leh0zf5br1',
      bonus18: 'lejgrf7lrm',
      bonus19: 'lecksafsag',
      bonus20: 'lezrokq9br',
      bonus21: 'leqyfmq7zm',
      bonus22: 'leerl8kqdw',
      bonus23: 'lecht1vba3',
      bonus24: 'letss60b1h',
      bonus25: 'le8wi7gasq',
      bonus26: 'lem16pvl8p',
      bonus27: 'lejpo7gdv3',
      bonus28: 'lexbi78ino',
      bonus29: 'lewi3zpd5j',
      bonus30: 'lep0ww0q8t',
      bonus31: 'lefa5fyr2k',
      bonus32: 'ledu2jtkab',
      bonus33: 'le9cm3sw5g',
      bonus34: 'lenpte3zvr',
      bonus35: 'le6o1auq7c',
      bonus36: 'levgs4p1sn',
      bonus37: 'lekeerx6t8',
      bonus38: 'leeyqdufvd',
      bonus39: 'lewpqvgojr',
      bonus40: 'let0dc0nzd',
      bonus41: 'le0kzl0x9w',
      bonus42: 'lea8etrapr',
      bonus43: 'lem47s4hh9',
      bonus44: 'le3d9cqdnn',
      bonus45: 'lepid42bp3',
      bonus46: 'lec6smofs0',
      bonus47: 'leb1rgkcqr',
      bonus48: 'le7u0x3wcj',
      bonus49: 'levywmzl89',
      bonus50: 'leqywg4b6v',
      bonus51: 'le8mqrl3lx',
      bonus52: 'le1z57natp',
      bonus53: 'lev5usrnrq',
      bonus54: 'leg8tgywdh',
      bonus55: 'leid45xg1k',
      bonus56: 'lenfbb3p6p',
      bonus57: 'leokas73c8',
      bonus58: 'leoegq4id0',
      bonus59: 'lek562m9fa',
      bonus60: 'lex38jzwbz',
      bonus61: 'lew0dcista',
      bonus62: 'leoco27jz8',
      bonus63: 'lexgyu8apd',
      bonus64: 'le54smknhb',
      bonus65: 'le0ealdber',
      bonus66: 'leotp3lvql',
      bonus67: 'leep7z3rng',
      bonus68: 'lee1oz2kkz',
      bonus69: 'lefcwk3c2h',
      bonus70: 'lejjgib9v1',
      bonus71: 'leyw11o5mj',
      bonus72: 'lek6j9zr03',
      bonus73: 'leyi4177ap',
      bonus74: 'lebeuttwg5',
      bonus75: 'le16iwr3vy',
      bonus76: 'leuuh72yi2',
      bonus77: 'leczlv0ii2',
      bonus78: 'leaq350y0a',
      bonus79: 'lez5n2gfio',
      bonus80: 'le0urp1t72',
      bonus81: 'le4jdktnmb',
      bonus82: 'le1e1ljwgi',
      bonus83: 'legth031go',
      bonus84: 'lez385w6i9',
      bonus85: 'lecs3631bx',
      bonus86: 'lex08agdbp',
      bonus87: 'legw4wa91y',
      bonus88: 'let5mozioj',
      bonus89: 'lez0h1aa3j',
      bonus90: 'lefht4avdm',
      bonus91: 'le6xpjxdnw',
      bonus92: 'lezqxafw4f',
      bonus93: 'leon1v7gca',
      bonus94: 'letq74y9or',
      bonus95: 'leufsmp4fw',
      bonus96: 'leicobn216',
      bonus97: 'lej3b2fdii',
      bonus98: 'le81v442h2',
      bonus99: 'lebg4wbthz',
      bonus100: 'lexby1t9db',
      bonus101: 'lemr5228e9',
      bonus102: 'legzxdxoc0',
      bonus103: 'le79cphyhi',
      bonus104: 'leiiomkt1p',
      bonus105: 'le424ed6b0',
      bonus106: 'leqro3uqoh',
      bonus107: 'leuq3n69q8',
      bonus108: 'le5m1w6b32',
      bonus109: 'lelgnvqaea',
      bonus110: 'leql906sur',
      bonus111: 'le84o3h2ua',
      bonus112: 'lexvwxi586',
      bonus113: 'leknqqlkoz',
      bonus114: 'le7mmx4bk2',
      bonus115: 'le03kax35i',
      bonus116: 'leeiztmwj8',
      bonus117: 'leldz1i4bs',
      bonus118: 'le0t0jowdg',
      bonus119: 'le7p0so4ih',
      bonus120: 'lea4tame8e',
      bonus121: 'ley7dsjuui',
      bonus122: 'lepoqqai30',
      bonus123: 'le5jf6342k',
      bonus124: 'lel0j1ekph',
      bonus125: 'le40162lfs',
      bonus126: 'leyk3gan9q',
      bonus127: 'le6auntokw',
      bonus128: 'leu3jc56js',
      bonus129: 'lede1g87cu',
      bonus130: 'lev64qct38',
      bonus131: 'lenrd4z2ly',
      bonus132: 'le46er7255',
      bonus133: 'le8o6h3ud7',
      bonus134: 'lenw8i3ty7',
      bonus135: 'len0z7kbdk',
      bonus136: 'lekqvutv5q',
      bonus137: 'leqnw3dfk6',
      bonus138: 'letpq5zpa8',
      bonus139: 'lez1omjsg3',
      bonus140: 'lethrc5lrh',
      bonus141: 'lerbhbmti8',
      bonus142: 'led6vuney0',
      bonus143: 'lenm10z4ah',
      bonus144: 'leth65i26d',
      bonus145: 'lem6756zxn',
      bonus146: 'le27iq8v9d',
      bonus147: 'le784ai2r4',
      bonus148: 'leiwmb8h9c',
      bonus149: 'letmy7pazl',
      bonus150: 'lerm39qlta',
      bonus151: 'leahn0z9me',
      bonus152: 'le6pqcee6z',
    },
  },
  // cypress plugins
  {
    courseId: 'coztjw6spx',
    slug: 'cypress-plugins',
    title: 'Cypress Plugins',
    description:
      'An advanced course teaching how to extend Cypress functionality via its plugins',
    // undraw.co icon with color #F50057
    // called "portfolio update"
    // redirects from human lesson ids like "bonus10" to CourseKit lesson IDs
    // IMPORTANT: next.config.js generates redirects from this object
    lessons: {
      intro: 'lefm6a8zch',
      introduction: 'lefm6a8zch',
      'plugin-architecture': 'le8i04xhr9',
      multiple: 'le10un2yxr',
      a1: 'led6p62p8u',
      a2: 'le9nauof2v',
      a3: 'leicgevb0e',
      a4: 'lermn2nv50',
      a5: 'ley5q8u67n',
      a6: 'leg8zhcxw2',
      a7: 'lekwu2uzew',
      a8: 'let83ru8co',
      a9: 'le0d0hq0ws',
      a10: 'le5q3l9pzg',
      a11: 'le78g5z23m',
      b1: 'lelvdyskiw',
      b2: 'lej9kbgfwx',
      b3: 'le7jzpfwyw',
      c1: 'lekr4l4skq',
      c2: 'lef4pqh9ra',
      c3: 'leamy19tf9',
      c4: 'lebhy6ifdi',
      c5: 'le9nb1ja1h',
      c6: 'lebbkhn436',
      c7: 'let9peea0o',
      c8: 'lee67mnm8w',
      c9: 'lemqmcwu32',
      c10: 'lexnjsr62d',
      d1: 'let1xaqjzn',
      d2: 'lekjcblfih',
      d3: 'leai1o7472',
      d4: 'le8by0u6rv',
      d5: 'lepuv20do2',
      d6: 'leqvpaocrz',
      e1: 'leo90bzxhk',
      e2: 'lec35174pa',
      e3: 'le5eb71kul',
      e4: 'lewpcbeegg',
      f1: 'le0u06ivl5',
      f2: 'le20lqu0xc',
      f3: 'le55cqrtob',
      f4: 'leqcpyplc9',
      f5: 'led032nf5o',
      f6: 'le21dptdtb',
      f7: 'lepuu1ba6v',
      f8: 'lex1cofd6m',
      f9: 'leuhls58l3',
      f10: 'leievp1vbl',
      f11: 'let8fbsnhd',
      f12: 'le7txrbhsg',
      f13: 'lecvmpy6wd',
      f14: 'lehhpbef6s',
      f15: 'lea7we69au',
      g1: 'le42lu32af',
      g2: 'lee17674cq',
      g3: 'leaequi09r',
      g4: 'lebuqcad8d',
      g5: 'lezwof0vv7',
      g6: 'leqtutpf8s',
      h1: 'lee1ecjqlh',
      h2: 'leuzx1384w',
      h3: 'le5p9lmmsl',
      i1: 'leakw35y02',
      i2: 'leayfuhd0s',
      i3: 'lemrrv92ht',
      i4: 'ledbduxc76',
      i5: 'ler0wrx4m4',
      i6: 'leffaobj5f',
      i7: 'lefua9a2jr',
      i8: 'lel57gcdql',
      i9: 'le2t5m0pvh',
      i10: 'le6gh4hucf',
      i11: 'lelwyo3ajs',
      k1: 'lepev1fhae',
      k2: 'le3661ia88',
      k3: 'leff9h66q4',
      k4: 'lebg3bxw36',
      k5: 'letfwzsvnw',
      k6: 'letpl1tgsu',
      k7: 'lem7tioxhu',
      k8: 'lefm3hwe41',
      k9: 'leeb6utiqj',
      k10: 'lenmtwf1ii',
      k11: 'leyp9a5yf1',
      k12: 'lelbilp05d',
      j1: 'le4e84w0ij',
      j2: 'leg2w0vy22',
      j3: 'le6akqbu4u',
      j4: 'lekgliiae0',
      j5: 'lejywso6g2',
      j6: 'le2knni032',
      l1: 'letmtuq3gd',
      l2: 'leotpa7xku',
      l3: 'lecvzifma6',
      l4: 'lepbhrsyyo',
      l5: 'le9wfd43ao',
      l6: 'lew8uf698u',
      l7: 'le03kvu04h',
      l8: 'le7vb60hpd',
      l9: 'leqisw4ayy',
      l10: 'lexh1klq6g',
      l11: 'le366b0db9',
      l12: 'le9wrckj8z',
      l13: 'leyg6cpm3j',
      l14: 'leobd2vjb2',
      l15: 'lewx5phrvf',
      l16: 'lem8a3cw1v',
      l17: 'le0cgiisk9',
      l18: 'lerf5l8rii',
      m1: 'lezkdvelfw',
      m2: 'leyap9t5gf',
      m3: 'lejxclmqvq',
      m4: 'leyk8uo7al',
      m5: 'ledjjtsxc4',
      m6: 'leluflf7wp',
      n1: 'lea1plz24o',
      n2: 'lepva6j29f',
      n3: 'leplaixz4n',
      n4: 'leqxq4md42',
      n5: 'lewhix7m8e',
      n6: 'lejbb176l9',
      n7: 'lefw37u5vr',
      n8: 'le2xca30g3',
      n9: 'lejqq73aeq',
      n10: 'lek6s7j3jf',
      o1: 'le2ea99jhl',
      o2: 'letgtl68ic',
      o3: 'lec3paopzy',
      o4: 'les30ryhgo',
      o5: 'leo83gfo59',
      o6: 'leu4557d7q',
      o7: 'leo8rvvb8d',
      o8: 'leczs82ofo',
      o9: 'le3gtgrxlc',
      o10: 'leds8wdxru',
      p1: 'lec9zxixvz',
      p2: 'leyp1k9p3m',
      p3: 'leon1vntfv',
      p4: 'leo3mjffnc',
      p5: 'letuuysiw6',
      r1: 'ledvb2jtdq',
      r2: 'les51nfhqn',
      r3: 'le44kobutp',
      r4: 'ley3w9ehp4',
      r5: 'let2zbbwgr',
    },
  },
  // visual testing
  {
    courseId: 'cov8byve72',
    slug: 'visual-testing',
    title: 'Visual Testing With Cypress',
    description:
      'An advanced course showing open source and paid visual testing Cypress plugins',
    // undraw.co icon with color #E45A07
    // called "portfolio update"
    // redirects from human lesson ids like "bonus10" to CourseKit lesson IDs
    // IMPORTANT: next.config.js generates redirects from this object
    lessons: {
      intro: 'lei7pqhqeh',
      introduction: 'lei7pqhqeh',
      a1: 'levjay3i3a',
      a2: 'less712roh',
      a3: 'lei9csspnp',
      a4: 'le6lyp7njr',
      a5: 'le9cnrlg8g',
      a6: 'le2c6j1i29',
      a7: 'leuemzssir',
      a8: 'lew1rmatir',
      a9: 'le612yijj6',
      b1: 'leploiodm9',
      b2: 'leusn0bor0',
      b3: 'le670rd2cj',
      b4: 'lexqbp13tg',
      b5: 'lehi2e3b6s',
      b6: 'lerb6imaxm',
      b7: 'lewa729rwf',
      b8: 'lew0wfk4aw',
      c1: 'ley3ptx3h2',
      c2: 'le6q2f8tkr',
      c3: 'lekm4hp2r2',
      c4: 'lekz9sxnrl',
      c5: 'lehhwt2pf3',
      c6: 'le3cwefeal',
      c7: 'leq9m94so7',
      c8: 'le8m56v9tr',
      d1: 'leb91uexmy',
      d2: 'lexnpe5z3p',
      d3: 'le19ghpih9',
      d4: 'le9rmiojme',
      d5: 'lehwzfi6o3',
      d6: 'lenmtors3o',
      d7: 'lee14x5rel',
      d8: 'le81md1plu',
      d9: 'lecv60fyv5',
      e1: 'let6iqxz3e',
      e2: 'le2t8dwp63',
      e3: 'le0fumvmqh',
      e4: 'leqbvzbbkr',
      e5: 'lemk4jquz6',
      e6: 'le1uz3wsi0',
      f1: 'lehf4t9k9s',
      f2: 'le7py4hfqr',
      f3: 'le7owp4v3v',
      f4: 'lesjjs1hg1',
      f5: 'le92qgi2an',
      g1: 'lel323mky6',
      g2: 'lec896z9yb',
      g3: 'leukycy36v',
      g4: 'lehzziv75q',
      g5: 'legii615x0',
      g6: 'lew8d5gfzv',
      g7: 'le0uq5g00r',
      end: 'leoyqrjfk2',
      bonus01: 'lejx13kwf5',
      bonus02: 'lemye7z0ew',
      bonus03: 'lekctahgjb',
      bonus04: 'lexfen6pyj',
      bonus05: 'lelzea0mu4',
    },
  },
]

courses.forEach((course) => {
  // invert the lessons objects to quickly find human lesson slugs by id
  course.lessonSlugs = {}
  if (course.lessons) {
    const lessonPairs = Object.entries(course.lessons)
    lessonPairs.forEach(([slug, id]) => {
      if (course.lessonSlugs[id]) {
        return
      }
      course.lessonSlugs[id] = slug
    })
  }
})

/**
 * Finds the course object by its id
 * @param {string} courseId The course id
 */
function findCourseById(courseId) {
  return courses.find((course) => course.courseId === courseId)
}

/**
 * Finds the course object by its human-friendly slug
 * @param {string} slug The course slug
 */
function findCourseBySlug(slug) {
  return courses.find((course) => course.slug === slug)
}

/**
 * Finds the course object by its title
 * @param {string} title The course title
 */
function findCourseByTitle(title) {
  return courses.find((course) => course.title === title)
}

module.exports = {
  findCourseById,
  findCourseByTitle,
  findCourseBySlug,
}
